module.exports = __webpack_public_path__ + "static/media/Icono In progressPurple.b29313fe.svg";